import { render, staticRenderFns } from "./PortIndex.vue?vue&type=template&id=3022dbea&scoped=true&"
import script from "./PortIndex.vue?vue&type=script&lang=js&"
export * from "./PortIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3022dbea",
  null
  
)

export default component.exports